import { IPriceCart, MSSMembers, MSSProduct } from './IMembershipDetails';
import { MembershipLevel, CurrentPayPlan, MSSProspectiveCosts } from '@ace-clublabs/common-membership-api-types';

export interface ICalculateCostRequest {
  sessionId?: string;
  billPlan: CurrentPayPlan;
  membershipLevel: MembershipLevel;
  membershipProducts: MSSProduct[];
  members: MSSMembers[];
  campaignCode?: string;
  useCache: boolean;
  memberData?: {
    eightDigitMemberNumber: string;
    employeeNumber: string;
    clubCode: string;
    inRenewal: boolean;
    inArrears?: boolean;
  };
}

export interface ICalculateCostResponse {
  priceCart: IPriceCart;
  mbpPriceCart?: IPriceCart;
  prospectiveCosts: MSSProspectiveCosts;
  additionalDiscounts: AdditionalDiscount[] | any;
}

export interface AdditionalDiscount {
  type: AdditionalDiscountType;
  value: number;
}

export enum AdditionalDiscountType {
  RENEWAL = 'RENEWAL',
  MEMBERSHIP = 'MEMBERSHIP',
  RETIREE = 'RETIREE',
  EMPLOYEE = 'EMPLOYEE',
  TMOBILE_YOU = 'TMOBILE_YOU',
}
